import { render, staticRenderFns } from "./TextFragmentForm.vue?vue&type=template&id=fc74c61e&scoped=true"
import script from "./TextFragmentForm.vue?vue&type=script&lang=js"
export * from "./TextFragmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc74c61e",
  null
  
)

export default component.exports